
try {
  Sentry.init({
    dsn: 'https://ae88c563a11f4b84a6b2699639fb6f8e@sentry.io/1187044',
  });
} catch (err) {
  console.log('Sentry init failed', err);
}

FHIR.oauth2.ready()
  .then(function(client) {

/*
  Data model

  Concept: sctid
  Refinement: Q*
  Group: R*
  Query: C*, R*, G*
  Let: Q

*/

function toCanonicalEcl(ecl) {
  // trim concept labels and excess whitespace
  return ecl
         .replace(/\|[^|]*\|/g,' ')	// trim terms
         .replace(/[ \t\n]+/g, ' ')	// trim whitespace
         .replace(/(<<|>>)\s*\*/, '*')	// optimise
         ;
}

// Initialize the FirebaseUI Widget using Firebase.
var firedb;
try {
  firedb = firebase.firestore();
} catch (err) {
  console.log('Failed to init Firebase', err);
}

// Stub to support diagrammingView.js
const Endpoint = {
  _language: undefined,

  '$http': undefined,
  lookupConcepts: (options, callback) => {
    const {codings, fields} = options;
    const props = fields.join('&property=');

    const entries = codings.map(c => {
      var params = [
          'code='+encodeURI(c.c),
          'system='+encodeURI(c.s),
      ];
      if (c.v) { params.push('version='+encodeURI(c.v)); }
      return {
        'request': {
          'method': 'GET',
          'url': 'CodeSystem/$lookup?'+params.join('&') + '&property='+props // '&property=display&property=parent&property=designation&property=inactive' //,processFields(options.fields),
        },
      };
    })

    Endpoint.$http.post(Endpoint.ep, JSON.stringify({
      resourceType: 'Bundle',
      type: 'batch',
      entry: entries
    }), {
      headers: {
        'content-type': 'application/fhir+json'
      }
    }).then(function (result) {
      callback(undefined, result.data.entry);
    });

  },

  getLanguage: function () {
    return Endpoint._language || navigator.language;
  },

  setLanguage: function (lang) {
    if (lang !== Endpoint._language) {
      Endpoint._language = lang;
    }
  },

};

var app = angular.module('eclbuilder', ['ui.bootstrap', 'ngSanitize']);

app.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('FhirAuthRequestInterceptor');
}]).factory('FhirAuthRequestInterceptor', ['$q', '$location',
  function ($q, $location) {
    return {
      'request': function (config) {
        if (config.url.startsWith(client.state.serverUrl)) {
          var token = client.state.tokenResponse.access_token;
          if (token) {
            config.headers.Authorization = 'Bearer ' + token;
          }
        }
        return config || $q.when(config);
      },
      'responseError': function (rejection) {
        // Not properly/well tested
        console.log("Found responseError: ", rejection);
        if (rejection.status == 401) {
          console.log("Access denied (error 401), please login again");
          //$location.nextAfterLogin = $location.path();
          $location.path('launch.html?iss=' + client.state.serverUrl);
        }
        return $q.reject(rejection);
      }
    }
  }]);

app.filter('to_trusted', ['$sce', function($sce){
  return function(text) {
    return $sce.trustAsHtml(text);
  };
}]);

app.filter('formatDisplay', ['$sce', function($sce) {

  function mapCategory(label) {
    switch (label) {
      case '(trade product)':
        return '(TP)';
      case '(trade product pack)':
        return '(TPP)';
      case '(containered trade product pack)':
        return '(CTPP)';
      case '(trade product unit of use)':
        return '(TPUU)';
      case '(medicinal product)':
        return '(MP)';
      case '(medicinal product pack)':
        return '(MPP)';
      case '(medicinal product unit of use)':
        return '(MPUU)';
      default:
        return label;
    }
  }

  return function(x) {
    const fsn = {};

    (x.designation||[]).forEach(function (t) {
      if (t.use && t.use.code === '900000000000003001' && t.use.system === 'http://snomed.info/sct' && t.value.endsWith(')')) {
        fsn[t.language] = t.value;
      }
    });

    const availLang = new locale.Locales(Object.keys(fsn));
    const userLang = new locale.Locales(Endpoint.getLanguage());
    const bestMatch = userLang.best(availLang);

    x.fullySpecifiedName = fsn[bestMatch.toString()] || fsn[Object.keys(fsn)[0]];
    x.category = mapCategory( x.fullySpecifiedName.replace(/^.*[(]/,'').slice(0,-1) );

    var d = $sce.getTrustedHtml(x.display),
        c = $sce.getTrustedHtml(x.category);

    return d + '&nbsp;<span class="category" style="float:right">' + c + '</span>';
  };
}]);

app.directive('prismHighlight', function() {
  return {
    restrict: 'A',
    scope: {
      prismHighlight: '='
    },
    link: function(scope, element) {
      scope.$watch('prismHighlight', function(newVal) {
        if (newVal != null) {
          element.text(newVal);
          Prism.highlightElement(element[0]);
        }
      });
    }
  };
});

app.controller('MainCtrl', ['$scope', '$http', '$timeout', '$uibModal', function($scope, $http, $timeout, $uibModal) {
  $scope.options = {};

  var trace = false;

  var fireUpdates = {};
  function pushUpdates() {
    if ($scope.uid) {
      // var batch = firedb.batch();
      Object.keys(fireUpdates).forEach(function (id) {
        fireUpdates[id]($scope.uid);
      });
      // batch.commit().then(funtion() {
      // })['catch'](function(err) {
      // });
      fireUpdates = {};
    }
  }
  window.addEventListener('blur', pushUpdates);

  var queryParams = parseQueryString(window.location.search);
  queryParams.fhir = client.state.serverUrl;
  if (queryParams.fhir) {
    $scope.endpoint = decodeURIComponent(queryParams.fhir);
  } else {
    $scope.endpoint = 'https://tx.ontoserver.csiro.au/fhir';
  }
  $scope.newEndpoint = $scope.endpoint;

  document.getElementById('eplogo').src = $scope.endpoint + '/.well-known/organisation_logo.png'
  document.getElementById('fhir-server-link').href = $scope.newEndpoint.startsWith('https://api.healthterminologies.gov.au/integration/') ? ('ONTOCMD/launch?iss=' + encodeURI($scope.newEndpoint)) : $scope.newEndpoint;

  if (queryParams.download) {
    window.localStorage.setItem('download', queryParams.download);
  }
  var match = window.localStorage.getItem('download') || undefined;
  if (match) queryParams.download = match;
  // console.log('MATCH', match, queryParams.download);
  $scope.download = queryParams.download;

  if ("csiro" === $scope.download) {
    document.getElementById('account').style.display = '';
  }

  $scope.fn = {
    createQ: function() {
      var n = Math.floor(Math.random() * 100000),
        uid = 'id-' + n;
      $scope.ecl = $scope.queries[uid] = init(uid);
      $scope.ecl.name = 'Untitled-' + n;
      $scope.options.qryid = uid;
      save($scope.ecl, $scope.queries)
    },
    selectQ: function(id) {
      $scope.ecl = $scope.queries[id];
      if ($scope.version !== $scope.ecl.version) {
        $scope.version = $scope.ecl.version;
      }
      save($scope.ecl, $scope.queries);
    },
    deleteQ: function(id) {
      $scope.options.qryid = undefined;
      if (($scope.ecl || {}).id === id) {
        $scope.ecl = {};
      }
      delete $scope.queries[id];
      save(undefined, $scope.queries);
      fireUpdates[id] = function(uid) {
        if (firedb) {
          firedb.collection("users").doc(uid).collection("queries").doc(id)['delete']()
            ['catch'](function (err) { console.log(err); });
        }
      }
    },
    clearQ: function() {
      $timeout(function() {
        $scope.ecl.name = "Untitled";
        $scope.ecl.inc.c.length = 0;
        $scope.ecl.inc.r.length = 0;
        $scope.ecl.inc.g.length = 0;
        $scope.ecl.exc.c.length = 0;
        $scope.ecl.exc.r.length = 0;
        $scope.ecl.inc.g.length = 0;
        this.addC($scope.ecl.inc);
        save(undefined, $scope.queries)
      });
    },
    mrcmMenu: function () {
      return Object.keys(mrcm);
    },
    createMrcm: function(name) {
      var n = Math.floor(Math.random() * 100000),
        uid = 'id-' + n;
      $scope.ecl = $scope.queries[uid] = initMrcm(uid,name);
      $scope.ecl.name = name + '-' + n;
      $scope.options.qryid = uid;
      save($scope.ecl, $scope.queries)
    },
    concepts: function(term, valueSet, endpoint) {
      valueSet = valueSet || 'http://snomed.info/sct?fhir_vs';
      endpoint = endpoint || $scope.endpoint;

      return $http({
          method: 'GET',
          url: endpoint + '/ValueSet/$expand',
          params: {
            'url': valueSet,
            'activeOnly': true,
            'includeDesignations': true,
            'filter': term,
            'count': 15,
            'displayLanguage': Endpoint.getLanguage(),
            '_format': 'json'
          },
          responseType: 'json'
        })
        .then(function(response) {
          // console.log('Search ' + term, response.data.expansion.total);
          return response.data.expansion.contains || [];
        });
    },
    addL: function (q, l) {
      q.c.push(l || newL());
      return q;
    },
    addT: function (q, t) {
      q.c.push(t || newT());
      return q;
    },
    addC: function(q, c) {
      q.c.push(c || newC());
      return q;
    },
    addR: function(q) {
      q.r.push(newR());
      return q;
    },
    addG: function(q) {
      q.g.push(newG());
      return q;
    },
    addGR: function(g) {
      console.log('ADD GR', g);
      g.rels.push(newR());
      return g;
    },
    parseT: function(q, t) {
      var result = EclParser.eclToQuery(t.expression || '');
      var inc = result.inc;
      var idx = q.c.indexOf(t);
      if (idx < 0) return;

      // Collect all concept nodes missing display text
      var concepts = [];
      (function walk(node) {
        if (!node) return;
        if (node.type === 'c' && node.id && node.id.code && !node.id.display) concepts.push(node);
        if (node.type === 'q') {
          (node.c || []).forEach(walk);
          (node.r || []).forEach(walk);
          (node.g || []).forEach(walk);
        }
        if (node.type === 'r') { walk(node.rel); walk(node.val); }
        if (node.type === 'g') (node.rels || []).forEach(walk);
      })({type:'q', c: inc.c, r: inc.r, g: inc.g});

      function applyResult() {
        var args = [idx, 1].concat(inc.c);
        Array.prototype.splice.apply(q.c, args);
        q.r = q.r.concat(inc.r);
        q.g = q.g.concat(inc.g);
        if (inc.opC) q.opC = inc.opC;
        if (inc.opR) q.opR = inc.opR;
      }

      if (concepts.length === 0) {
        applyResult();
        return;
      }

      var version = $scope.version;
      Endpoint.lookupConcepts({
        codings: concepts.map(function(c) { return { s: 'http://snomed.info/sct', c: c.id.code, v: version }; }),
        fields: ['display'],
      }, function(error, entries) {
        concepts.forEach(function(c, i) {
          var display;
          if (!error && entries && entries[i] && entries[i].resource) {
            var param = (entries[i].resource.parameter || []).find(function(p) { return p.name === 'display'; });
            if (param) display = param.valueString;
          }
          c.id.display = display || c.id.code;
        });
        $timeout(applyResult);
      });
    },
    del: function(l, e) {
      var index = l.indexOf(e);
      if (index > -1) {
        l.splice(index, 1);
      }
    },
    card: function(r, prev) {
      if (r.card === 'other') {
        r.card = prev;
        $uibModal.open({
          animation: true,
          size: 'sm',
          template: '<div class="modal-header">' +
            '<h4 class="modal-title">Cardinality constraint</h4>' +
            '</div>' +
            '<div class="modal-body">' +
            "Use a max value of -1 to represent '*'" +
            '</div>' +
            '<div class="modal-footer">' +
            '  Min: <input class="form-control" type="number" min="0" ng-model="min">' +
            '  Max: <input class="form-control" type="number" min="-1" ng-model="max">' +
            '  <button class="btn btn-warning" type="button" ng-click="cancel()">Cancel</button>' +
            '  <button class="btn btn-primary" type="button" ng-click="ok()">OK</button>' +
            '</div>',
          controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
            $scope.min = 1;
            $scope.max = -1;

            $scope.cancel = function() {
              $uibModalInstance.close();
            };
            $scope.ok = function() {
              r.card2 = $scope.min + '..' + ($scope.max < 0 ? '*' : $scope.max);
              r.card = r.card2 === '1..*' ? '' : r.card2;
              console.log('CARD', r.card);
              if (['0..0', '0..*', '', '1..1', '0..1', '2..*'].indexOf(r.card) >= 0) {
                r.card2 = undefined;
              }
              $uibModalInstance.close();
            };
          }],
        });
      } else {
        r.card2 = undefined;
      }
    }
  };

  function parseQueryString( queryString ) {
    var params = {},
        queries;
 
    // Split into key/value pairs
    queries = queryString.replace(/^\?/,"").split("&");
 
    // Convert the array of strings into an object
    queries.forEach(function (query) {
      var temp = query.split('=');
      if ('fhir' === temp[0]) {
        params[temp[0]] = temp[1];
      } else if (typeof params[temp[0]] === "undefined") {     // ==0
        params[temp[0]] = temp[1] || "true";
      } else if (Array.isArray(params[temp[0]])) {      // >1
        params[temp[0]].push(temp[1]);
      } else {
        params[temp[0]] = [params[temp[0]], temp[1]];   // ==1
      }
    });
 
    return params;
  }

  function newT(expression) {
    return {
      type: 't',
      expression: expression,
    };
  }

  function newL(uid, op) {
    return {
      type: 'l',
      uid: uid,
      opC: op || '',
    };
  }

  function newQ(c, r, g, opC, opR) {
    if (trace) console.log('newQ', c, r, g, opC, opR);
    if (c && c.find(function (x) { return x.type !== 'c'; })) {
      if (c.find(function (x) { return x.type === 'q'; }) && 1 === c.length && !(r || g || opC || opR)) {
        return c[0];
      }
      throw "expected c, got " + c.map(function (x) { return x.type; });
    }
    if (r && r.find(function (x) { return x.type !== 'r'; })) throw "expected r, got " + c.map(function (x) { return x.type; });
    if (g && g.find(function (x) { return x.type !== 'g'; })) throw "expected g, got " + c.map(function (x) { return x.type; });
    return {
      type: 'q',
      opC: opC || 'AND',
      c: c || [],
      opR: opR || 'AND',
      r: r || [],
      g: g || [],
    };
  }

  function newC(code, op, display) {
    if (trace) console.log('newC', code, op, display);
    if (!code && display) throw "expected code";
    if (code && !display) throw "expected display";
    return {
      type: 'c',
      opC: op || '',
      id: {
        code: code,
        display: display,
      }
    };
  }

  function newR(rel, val, card, cmp) {
    if (trace) console.log('newR', rel, val, card, 'XX', $scope.fn.addC(newQ()));
    if (rel && rel.type !== 'c') throw "expected c";
    if (val && val.type !== 'q') throw "expected q";
    return {
      type: 'r',
      card: card,
      rel: rel || newC(),
      val: val || $scope.fn.addC(newQ()),
      cmp: cmp || '=',
    };
  }

  function newG(rels, card) {
    if (trace) console.log('newG', rels, card);
    if (rels) {
      if (!Array.isArray(rels)) throw "expected array, got " + rels;
      if (rels.find(function (x) { return x.type !== 'r'; })) throw "expected r, got " + rels.map(function (x) { return x.type; });
    }
    return {
      type: 'g',
      card: card,
      rels: rels || [newR()],
    };
  }

  function save(ecl, queries) {
    if (ecl) {
      ecl.ecl = queryToEcl([], ecl, '');
      window.localStorage.setItem('id', ecl.id);
    } else {
      window.localStorage.setItem('id', undefined);
    }

    window.localStorage.setItem('queries', JSON.stringify(queries));
  }

  function init(id) {
    return {
      id: id,
      name: "Untitled",
      inc: $scope.fn.addC(newQ()),
      exc: newQ(),
    };
  }

  var mrcm = {

    // [[+id(<< 71388002 |Procedure (procedure)|)]]: [[0..*]] {
    //    [[0..1]] 260507000 |Access| = [[+id(<< 309795001 |Surgical access values (qualifier value)|)]],

    //    [[0..*]] 405815000 |Procedure device| = [[+id(<< 49062001 |Device (physical object)|)]],
    //    [[0..*]] 405816004 |Procedure morphology| = [[+id(<< 49755003 |Morphologically abnormal structure (morphologic abnormality)|)]],
    //    [[0..*]] 363704007 |Procedure site| = [[+id(<< 442083009 |Anatomical or acquired body structure (body structure)|)]],

    //    [[0..1]] 370131001 |Recipient category| = [[+id(<< 125676002 |Person (person)| OR << 35359004 |Family (social concept)| OR << 133928008 |Community (social concept)| OR << 105455006 |Donor for medical or surgical procedure (person)| OR << 389109008 |Group (social concept)|)]],
    //    [[0..1]] 246513007 |Revision status| = [[+id(<< 261424001 |Primary operation (qualifier value)| OR << 255231005 |Revision - value (qualifier value)| OR << 257958009 |Part of multistage procedure (qualifier value)|)]],
    //    [[0..1]] 425391005 |Using access device| = [[+id(<< 49062001 |Device (physical object)|)]],
    //    [[0..*]] 424226004 |Using device| = [[+id(<< 49062001 |Device (physical object)|)]], [[0..1]] 424244007 |Using energy| = [[+id(<< 78621006 |Physical force (physical force)|)]], [[0..1]] 424361007 |Using substance| = [[+id(<< 105590001 |Substance (substance)|)]] }
    procedure: newQ(
      [newC(71388002, '<<', 'Procedure (procedure)')],
      undefined,
      [
       newG([
         newR(newC(363704007, undefined, 'Procedure site'), newQ([newC(442083009, '<<', 'Anatomical or acquired body structure (body structure)')])),
         newR(newC(405813007, undefined, 'Procedure site - Direct'), newQ([newC(442083009, '<<', 'Anatomical or acquired body structure (body structure)')])),
         newR(newC(405814001, undefined, 'Procedure site - Indirect'), newQ([newC(442083009, '<<', 'Anatomical or acquired body structure (body structure)')])),
         newR(newC(260507000, undefined, 'Access'), newQ([newC(309795001, '<<', 'Surgical access values (qualifier value)')]), '0..1'),
         newR(newC(363699004, undefined, 'Direct device'), newQ([newC(49062001, '<<', 'Device (physical object)')]), '0..1'),
         newR(newC(363700003, undefined, 'Direct morphology'), newQ([newC(49755003, '<<', 'Morphologically abnormal structure (morphologic abnormality)')]), '0..1'),
         newR(newC(363701004, undefined, 'Direct substance'), newQ([newC(105590001, '<<', 'Substance (substance)'), newC(373873005, '<<', 'Pharmaceutical / biologic product (product)')], undefined, undefined, 'OR'), '0..1'),
         newR(newC(363702006, undefined, 'Has focus'), newQ([newC(404684003, '<<', 'Clinical finding (finding)'), newC(71388002, '<<', 'Procedure (procedure)')], undefined, undefined, 'OR'), '0..1'),
         newR(newC(363703001, undefined, 'Has intent'), newQ([newC(363675004, '<<', 'Intents (nature of procedure values) (qualifier value)')]), '0..1'),
         newR(newC(363710007, undefined, 'Indirect device'), newQ([newC(49062001, '<<', 'Device (physical object)')]), '0..1'),
         newR(newC(363709002, undefined, 'Indirect morphology'), newQ([newC(49755003, '<<', 'Morphologically abnormal structure (morphologic abnormality)')]), '0..1'),
         newR(newC(260686004, undefined, 'Method'), newQ([newC(129264002, '<<', 'Action (qualifier value)')]), '0..1'),
         newR(newC(260870009, undefined, 'Priority'), newQ([newC(272125009, '<<', 'Priorities (qualifier value)')]), '0..1'),

         newR(newC(405815000, undefined, 'Procedure device'), newQ([newC(49062001, '<<', 'Device (physical object)')]), '0..*'),
         newR(newC(405816004, undefined, 'Procedure morphology'), newQ([newC(49755003, '<<', 'Morphologically abnormal structure (morphologic abnormality)')]), '0..*'),
         newR(newC(363704007, undefined, 'Procedure site'), newQ([newC(442083009, '<<', 'Anatomical or acquired body structure (body structure)')]), '0..*'),

         newR(newC(370131001, undefined, 'Recipient category'), newQ([
             newC(125676002, '<<', 'Person (person)'),
             newC(35359004, '<<', 'Family (social concept)'),
             newC(133928008, '<<', 'Community (social concept)'),
             newC(105455006, '<<', 'Donor for medical or surgical procedure (person)'),
             newC(389109008, '<<', 'Group (social concept)')
          ], undefined, undefined, 'OR'), '0..1'),
         newR(newC(246513007, undefined, 'Revision status'), newQ([
             newC(261424001, '<<', 'Primary operation (qualifier value)'),
             newC(255231005, '<<', 'Revision - value (qualifier value)'),
             newC(257958009, '<<', 'Part of multistage procedure (qualifier value)')
          ], undefined, undefined, 'OR'), '0..1'),
         newR(newC(425391005, undefined, 'Using access device'), newQ([newC(49062001, '<<', 'Device (physical object)')]), '0..1'),

         newR(newC(424226004, undefined, 'Using device'), newQ([newC(49062001, '<<', 'Device (physical object)')]), '0..*'),
         newR(newC(424244007, undefined, 'Using energy'), newQ([newC(78621006, '<<', 'Physical force (physical force)')]), '0..1'),
         newR(newC(424361007, undefined, 'Using substance'), newQ([newC(105590001, '<<', 'Substance (substance)')]), '0..1'),
       ], '0..*')
     ]
    ),
    'finding with context': newQ([newC(243796009, "<<", "Situation with explicit context (situation)")], undefined, [newG([newR(newC(408729009, undefined, "Finding context"), newQ([newC(410514004, "<<", "Finding context value (qualifier value)")], undefined, undefined), ""),newR(newC(408731000, undefined, "Temporal context"), newQ([newC(410510008, "<<", "Temporal context value (qualifier value)")], undefined, undefined), ""),newR(newC(246090004, undefined, "Associated finding"), newQ([], undefined, undefined), "0..1"),newR(newC(408729009, undefined, "Finding context"), newQ([newC(410514004, "<<", "Finding context value (qualifier value)")], undefined, undefined), "0..1"),newR(newC(408732007, undefined, "Subject relationship context"), newQ([newC(125676002, "<<", "Person (person)")], undefined, undefined), "0..1"),newR(newC(408731000, undefined, "Temporal context"), newQ([newC(410510008, "<<", "Temporal context value (qualifier value)")], undefined, undefined), "0..1")], "0..*")]),
    'procedure with context': newQ([newC(243796009, "<<", "Situation with explicit context (situation)")], undefined, [newG([newR(newC(408730004, undefined, "Procedure context"), newQ([newC(288532009, "<<", "Context values for actions (qualifier value)")], undefined, undefined), ""),newR(newC(408731000, undefined, "Temporal context"), newQ([newC(410510008, "<<", "Temporal context value (qualifier value)")], undefined, undefined), ""),newR(newC(363589002, undefined, "Associated procedure"), newQ([newC(71388002, "<<", "Procedure (procedure)")], undefined, undefined), "0..1"),newR(newC(408730004, undefined, "Procedure context"), newQ([newC(288532009, "<<", "Context values for actions (qualifier value)")], undefined, undefined), "0..1"),newR(newC(408732007, undefined, "Subject relationship context"), newQ([newC(125676002, "<<", "Person (person)")], undefined, undefined), "0..1"),newR(newC(408731000, undefined, "Temporal context"), newQ([newC(410510008, "<<", "Temporal context value (qualifier value)")], undefined, undefined), "0..1")], "0..*")]),
    'finding with cause': newQ([newC(404684003, "<<", "Clinical finding (finding)")], undefined, [newG([newR(newC(255234002, undefined, "After"), newQ([newQ([newC(404684003, "<<", "Clinical finding (finding)"),newC(71388002, "<<", "Procedure (procedure)")], undefined, undefined, "OR")], undefined, undefined), "0..1"),newR(newC(47429007, undefined, "Associated with"), newQ([newQ([newC(404684003, "<<", "Clinical finding (finding)"),newC(71388002, "<<", "Procedure (procedure)"),newC(272379006, "<<", "Event (event)"),newC(410607006, "<<", "Organism (organism)"),newC(105590001, "<<", "Substance (substance)"),newC(260787004, "<<", "Physical object (physical object)"),newC(78621006, "<<", "Physical force (physical force)")], undefined, undefined, "OR")], undefined, undefined), "0..*"),newR(newC(288556008, undefined, "Before"), newQ([newC(71388002, "<<", "Procedure (procedure)")], undefined, undefined), "0..1"),newR(newC(246075003, undefined, "Causative agent"), newQ([newQ([newC(410607006, "<<", "Organism (organism)"),newC(105590001, "<<", "Substance (substance)"),newC(260787004, "<<", "Physical object (physical object)"),newC(78621006, "<<", "Physical force (physical force)")], undefined, undefined, "OR")], undefined, undefined), "0..1"),newR(newC(263502005, undefined, "Clinical course"), newQ([newC(288524001, "<<", "Courses (qualifier value)")], undefined, undefined), "0..1"),newR(newC(42752001, undefined, "Due to"), newQ([newQ([newC(404684003, "<<", "Clinical finding (finding)"),newC(272379006, "<<", "Event (event)"),newC(71388002, "<<", "Procedure (procedure)")], undefined, undefined, "OR")], undefined, undefined), "0..1"),newR(newC(371881003, undefined, "During"), newQ([newC(71388002, "<<", "Procedure (procedure)")], undefined, undefined), "0..1"),newR(newC(726634005, undefined, "During AND/OR after"), newQ([newQ([newC(404684003, "<<", "Clinical finding (finding)"),newC(71388002, "<<", "Procedure (procedure)")], undefined, undefined, "OR")], undefined, undefined), "0..*"),newR(newC(246456000, undefined, "Episodicity"), newQ([newC(288526004, "<<", "Episodicities (qualifier value)")], undefined, undefined), "0..1"),newR(newC(419066007, undefined, "Finding informer"), newQ([newQ([newC(420158005, "<<", "Performer of method (person)"),newC(419358007, "<<", "Subject of record or other provider of history (person)"),newC(444018008, "<<", "Person with characteristic related to subject of record (person)")], undefined, undefined, "OR")], undefined, undefined), "0..1"),newR(newC(418775008, undefined, "Finding method"), newQ([newC(71388002, "<<", "Procedure (procedure)")], undefined, undefined), "0..1"),newR(newC(363713009, undefined, "Has interpretation"), newQ([newQ([newC(260245000, "<<", "Finding values (qualifier value)"),newC(263714004, "<<", "Colors (qualifier value)")], undefined, undefined, "OR")], undefined, undefined), "0..1"),newR(newC(363714003, undefined, "Interprets"), newQ([newQ([newC(363787002, "<<", "Observable entity (observable entity)"),newC(108252007, "<<", "Laboratory procedure (procedure)"),newC(386053000, "<<", "Evaluation procedure (procedure)")], undefined, undefined, "OR")], undefined, undefined), "0..1"),newR(newC(246454002, undefined, "Occurrence"), newQ([newC(282032007, "<<", "Periods of life (qualifier value)")], undefined, undefined), "0..1"),newR(newC(370135005, undefined, "Pathological process"), newQ([newQ([newC(263680009, undefined, "Autoimmune (qualifier value)"),newC(441862004, "<<", "Infectious process (qualifier value)"),newC(472963003, "<<", "Hypersensitivity process (qualifier value)"),newC(308490002, "<<", "Pathological developmental process (qualifier value)")], undefined, undefined, "OR")], undefined, undefined), "0..1"),newR(newC(246112005, undefined, "Severity"), newQ([newC(272141005, "<<", "Severities (qualifier value)")], undefined, undefined), "0..1"),newR(newC(363705008, undefined, "Has definitional manifestation"), newQ([newC(404684003, "<<", "Clinical finding (finding)")], undefined, undefined), "0..*"),newR(newC(726633004, undefined, "Temporally related to"), newQ([newQ([newC(404684003, "<<", "Clinical finding (finding)"),newC(71388002, "<<", "Procedure (procedure)")], undefined, undefined, "OR")], undefined, undefined), "0..*"),newR(newC(363698007, undefined, "Finding site"), newQ([newC(442083009, "<<", "Anatomical or acquired body structure (body structure)")], undefined, undefined), "0..1"),newR(newC(116676008, undefined, "Associated morphology"), newQ([newC(49755003, "<<", "Morphologically abnormal structure (morphologic abnormality)")], undefined, undefined), "0..1")], "0..*")]),
  };

  function initMrcm(id,name) {
    return {
      id: id,
      name: "Untitled",
      inc: angular.copy(mrcm[name]),
      exc: newQ(),
    };
  }

  // restore state
  $scope.queries = JSON.parse(window.localStorage.getItem('queries') || '{}');

  var json = $scope.queries[window.localStorage.getItem('id')];
  if (json) {
    $scope.ecl = json;
    $scope.version = $scope.ecl.version;
  } else if (Object.keys($scope.queries).length === 0) {
    $scope.fn.createQ();
  }

  function migrate(q) {
    if (q.q) {
      console.log('MIGRATE', q.q);
      q.c = q.c || q.q.filter(function(x) { return x.type === 'c' });
      q.opC = q.opC || q.op;
      q.r = q.r || q.q.filter(function(x) { return x.type === 'r' });
      q.opR = q.opR || q.op;
      q.g = [];
      q.q = undefined;
    }
    if (!q.g) {
      q.g = [];
    }
  }

  var firedbUnsubscribe = function () {};

  try {
  firebase.auth().onAuthStateChanged(function(user) {
    console.log('Auth State', user);
    if (user) {
      // User is signed in.

      // Copy all local state up to Firestore
      Object.keys($scope.queries).forEach(function(id) {
        var q = $scope.queries[id];
        // console.log('FIREDB Store', id, q);
        var doc = firedb.collection("users").doc(user.uid).collection("queries").doc(id);
        if (q) {
          doc.set(q)
            ['catch'](function (err) { console.log(err); });
        } else {
          doc['delete']()
            ['catch'](function (err) { console.log(err); });
        }
      });

      $scope.$apply(function () {
        $scope.uid = user.uid;
        $scope.email = user.email;
      });

      // Copy all global state down from Firestore
      firedbUnsubscribe =
        firedb.collection("users").doc(user.uid).collection("queries").onSnapshot(function(snapshot) {
          console.log('FIREDB Query');
          $scope.$apply(function () {
            snapshot.docChanges().forEach(function(change) {
              var doc = change.doc;
              if (change.type === "added") {
                // console.log('ADD', `${doc.id} => `, doc.data());
                $scope.queries[doc.id] = doc.data();
              }
              if (change.type === "modified") {
                // console.log('MOD', change, doc.data());
                $scope.queries[doc.id] = doc.data();
              }
              if (change.type === "removed") {
                // console.log('DEL', `${doc.id}`);
                $scope.fn.deleteQ(doc.id);
              }
              if (($scope.ecl || {}).id === doc.id) {
                $scope.ecl = $scope.queries[doc.id] || {};
              }
            });
            window.localStorage.setItem('queries', JSON.stringify($scope.queries));
          });
        });

    } else {
      // User is signed out.
      // ...
console.log('Logging out');
      $scope.$apply(function () {
        $scope.uid = undefined;
        $scope.email = undefined;
      });
      firedbUnsubscribe();
      firedbUnsubscribe = function () {};
    }
    // ...
  });
} catch (err) {
  console.log('Firebase error', err);
}

  var origName;
  $scope.toEcl = function toEcl(ecl) {
    var origEcl = ecl.ecl,
        origVers = ecl.version;
    ecl.version = $scope.version;
    // save state
    save(ecl, $scope.queries);

    // avoid pointless updates
    if (ecl.id && (origEcl !== ecl.ecl || origName !== ecl.name || origVers !== ecl.version)) {
      fireUpdates[ecl.id] = function(uid) {
        if (firedb) {
        const clean = Object.entries(ecl).reduce((a,[k,v]) => (v === undefined ? a : (a[k]=v, a)), {});
        const fuser = firedb.collection("users");
        // if (!fuser) { console.log('No firebase user'); return; }
        const fdocs = fuser.doc(uid);
        // if (!fdocs) { console.log('No firebase docs'); return; }
        const fqueries = fdocs.collection("queries");
        // if (!fqueries) { console.log('No firebase queries'); return; }
        const fdocid = fqueries.doc(clean.id);
        // if (!fdocid) { console.log('No firebase doc.id'); return; }
        fdocid.set(clean)
          ['catch'](function (err) { console.log(err, clean); });
        }
      }
    }

    origName = ecl.name;

    return ecl.ecl;
  };

  function copy(value) {
    var
      body = angular.element(window.document.body),
      textarea = angular.element('<textarea/>');
    textarea.css({ position: 'fixed', opacity: '0' });
    textarea.val(value);
    body.append(textarea);
    textarea[0].select();
    try {
      var successful = document.execCommand('copy');
      if (!successful) throw successful;
    } catch (err) {
      console.log('Copy error', err);
    }
    textarea.remove();
  }

  $scope.copyEcl = function (ecl) {
    copy(toCanonicalEcl($scope.toEcl(ecl)));
  };

  $scope.copyVs = function (ecl) {
    copy('http://snomed.info/sct?fhir_vs=ecl/' + encodeURIComponent(toCanonicalEcl($scope.toEcl(ecl).trim())));
  };

  function queryToEcl(stack, ecl, indent) {
    var inc = qToEcl(stack, ecl.inc, false, indent);
    if (((ecl.exc.c||[]).length + (ecl.exc.r||[]).length + (ecl.exc.g||[]).length) > 0) {
      var exc = qToEcl(stack, ecl.exc, false, indent);
      return '(\n  ' + indent + inc + '\n' + indent + ') MINUS (\n  ' + indent + exc + '\n' + indent + ')';
    } else {
      return inc;
    }
  }

  function qToEcl(stack, q, nest, indent) {
    migrate(q);
    var mapToEcl = function(stack, y, op, s, i) {
        var ecl = y.map(function(x) {return eToEcl(stack, x, i)})
                   .filter(function(x) {return x;})
                   .join(op === 'AND' ? s : ' ' + op + ' ');
        return y.length > 1 ? '(' + ecl + ')' : ecl;
      },
      foci = q.c.filter(function(x) {return x.type === 'c' && (x.id.code || x.opC)}),
      nested = q.c.filter(function(x) {return (x.type === 'l' && x.uid && $scope.queries[x.uid]) || (x.type === 't' && x.expression)}),
      refine = q.r.filter(function(x) {return x.type === 'r'}),
      groups = q.g.filter(function(x) {return x.type === 'g' && x.rels.length > 0}),
      bracket = nest,
      fociEcl, refineEcl;

    if (foci.length === 0) {
      fociEcl = '*';
      bracket = false;
    } else if (foci.length === 1) {
      fociEcl = mapToEcl(stack, foci, q.opC, ' AND ', '  ' + indent);
      bracket = false;
    } else {
      fociEcl = mapToEcl(stack, foci, q.opC, ' AND ', '  ' + indent);
      bracket = true;
    }

    if (nested.length > 0) {
      var nestedEcl = mapToEcl(stack, nested, q.opC, ' AND ', '  ' + indent);
      if (foci.length === 0) {
        fociEcl = '  ' + nestedEcl;
        bracket = nest;
      } else {
        fociEcl = fociEcl + ' ' + q.opC + ' ' + nestedEcl;
        bracket = true;
      }
    }

    if (refine.length === 0 && groups.length === 0) {
      refineEcl = '';
    } else if (refine.length === 1 && groups.length === 0) {
      refineEcl = ' : ' + mapToEcl(stack, refine, q.opR, ', ', '  ' + indent);
      bracket = true;
    } else if (refine.length === 0 && groups.length === 1) {
      refineEcl = ' : ' + mapToEcl(stack, groups, q.opR, ', ', '  ' + indent);
      bracket = true;
    } else if (groups.length === 0) {
      refineEcl = ' : ' + mapToEcl(stack, refine, q.opR, ', ', '  ' + indent);
      bracket = true;
    } else if (refine.length === 0) {
      refineEcl = ' : ' + mapToEcl(stack, groups, q.opR, ', ', '  ' + indent);
      bracket = true;
    } else {
      var groupsEcl = mapToEcl(stack, groups, q.opR, ', ', '  ' + indent);
      refineEcl = ': ' + mapToEcl(stack, refine, q.opR, ', ', '  ' + indent) + ', ' + groupsEcl;
      bracket = true;
    }

    if (nest && bracket) {
      return '(\n  ' + indent + fociEcl + refineEcl + '\n' + indent + ')';
    } else {
      return fociEcl + refineEcl;
    }
  }

  function eToEcl(stack, e, indent) {
    switch (e.type) {
      case 'c':
        return cToEcl(stack, e, indent);
      case 'r':
        return rToEcl(stack, e, indent);
      case 'g':
        return gToEcl(stack, e, indent);
      case 'l':
        return lToEcl(stack, e, indent);
      case 't':
        return tToEcl(stack, e, indent);
      default:
        console.log('Unknown type in', e);
    }
  }

  function lToEcl(stack, l, indent) {
    if (stack.length > 20) return 'STACK OVERFLOW';
    var q = $scope.queries[l.uid];
    if (q) {
      if (stack.indexOf(l.uid) < 0) {
        var subEcl = '(\n  ' + indent + queryToEcl(stack.concat(l.uid), q, indent) + '\n' + indent + ')';
        return l.opC ? l.opC + ' ' + subEcl : subEcl;
      } else {
        console.log('Cyclic dependency chain via ', l.uid);
      }
    } else {
      console.log('Undefined query reference', l.uid);
    }
    return 'ERROR';
  }

  function tToEcl(stack, t, indent) {
    // Also strip spaces and check that it's not an empty string
    if (t.expression && t.expression.replace(/\s+/g, '').length) {
      return '(' + t.expression + ')';
    }
  }

  function cToEcl(stack, c, indent) {
    var label = c.id.display ? '|' + (c.id.display || 'Any') + '|' : '',
      code = (c.id.code || '*') + label;
      var result = c.opC ? c.opC + ' ' + code : code;
      if (c.opH) {
        result = '(' + result + ' {{ +' + c.opH + ' }})';
      }
      return result;
  }

  function rToEcl(stack, r, indent) {
    var card = r.card ? '[' + r.card + '] ' : '',
      val = qToEcl(stack, r.val, true, indent),
      rel = eToEcl(stack, r.rel, indent);
    r.cmp = r.cmp || '=';
    return card + rel + ' ' + r.cmp + ' ' + val;
  }

  function gToEcl(stack, g, indent) {
    var card = g.card ? '[' + g.card + '] ' : '',
      group = g.rels.map(function(x) {return rToEcl(stack, x, '  ' + indent)}).join(',\n  '+indent);
    return card + '{\n  ' + indent + group + '\n' + indent + '}';
  }

}]).directive('eQuery', function() {
  return {
    restrict: 'E',
    bindToController: true,
    controllerAs: 'ctrl',
    scope: {
      q: '=info',
      limit: '=',
      version: '=version',
    },
    templateUrl: 'e-query.html',
    transclude: true,
    controller: ['$scope', function($scope) {
      $scope.fn = $scope.$parent.fn;
      $scope.queries = $scope.$parent.queries;
    }],
  };

}).directive('eC', function() {
  return {
    restrict: 'E',
    bindToController: true,
    controllerAs: 'ctrl',
    scope: {
      q: '=info',
      c: '=?anchor',
      version: '=version',
    },
    templateUrl: 'e-c.html',
    controller: ['$scope', function($scope) {
      $scope.fn = $scope.$parent.fn;
      $scope.queries = $scope.$parent.queries;
    }],
  };

}).directive('eR', function() {
  return {
    restrict: 'E',
    bindToController: true,
    controllerAs: 'ctrl',
    scope: {
      q: '=info',
      version: '=version',
    },
    templateUrl: 'e-r.html',
    transclude: true,
    controller: ['$scope', function($scope) {
      $scope.fn = $scope.$parent.fn;
      $scope.queries = $scope.$parent.queries;
    }],
  };
  
}).directive('eG', function() {
  return {
    restrict: 'E',
    bindToController: true,
    controllerAs: 'ctrl',
    scope: {
      q: '=info',
      version: '=version',
    },
    templateUrl: 'e-g.html',
    transclude: true,
    controller: ['$scope', function($scope) {
      $scope.fn = $scope.$parent.fn;
      $scope.queries = $scope.$parent.queries;
    }],
  };

}).directive('sctVers', function() {
  function getVersions($scope, $http) {
    console.log('GV', $scope);
    var url = $scope.ctrl.endpoint + '/CodeSystem?system=http://snomed.info/sct&_elements=name,version',
        config = {
          'content-type': 'application/json+fhir',
          'accept': 'application/json+fhir',
        };
    return $http.get(url, config)
      .then(function (response) {
        $scope.versions = response.data.entry.map(function(e) {
          var vers = e.resource.version,
              offset = vers.indexOf('http://snomed.info/xsct') === 0 ? 1 : 0,
              versionName = vers.substring(23 + offset).replace('/version/', ' - ');

          if (vers.indexOf('/32506021000036107/') > 0) {
            versionName = 'AU - ' + vers.substring(49 + offset);
          } else if (vers.indexOf('/21000032107/') > 0) {
            versionName = 'PAH - ' + vers.substring(43 + offset);
          } else if (vers.indexOf('/999000031000000106/') > 0) {
            versionName = 'UK Edition (RS) - ' + vers.substring(50 + offset);
          } else if (vers.indexOf('/999000021000000109/') > 0) {
            versionName = 'UK Clinical - ' + vers.substring(50 + offset);
          } else if (vers.indexOf('/83821000000107/') > 0) {
            versionName = 'UK - ' + vers.substring(46 + offset);
          } else if (vers.indexOf('/999000041000000102/') > 0) {
            versionName = 'UK Edition - ' + vers.substring(50 + offset);
          } else if (vers.indexOf('/999000011000000102/') > 0) {
            versionName = 'UK Clinical (RS) - ' + vers.substring(50 + offset);
          } else if (vers.indexOf('/999000011000001104/') > 0) {
            versionName = 'UK Drug - ' + vers.substring(50 + offset);
          } else if (vers.indexOf('/900000000000207008/') > 0) {
            versionName = 'International - ' + vers.substring(50 + offset);
          } else if (vers.indexOf('/731000124108/') > 0) {
            versionName = 'US - ' + vers.substring(44 + offset);
          } else if (vers.indexOf('/449081005/') > 0) {
            versionName = 'Spanish - ' + vers.substring(41 + offset);
          } else if (vers.indexOf('/900000001000122104/') > 0) {
            versionName = 'Extensión España - ' + vers.substring(50 + offset);
          } else if (vers.indexOf('/11000221109/') > 0) {
            versionName = 'Argentina - ' + vers.substring(43 + offset);
          } else if (vers.indexOf('/11000172109/') > 0) {
            versionName = 'Belgium - ' + vers.substring(43 + offset);
          } else if (vers.indexOf('/554471000005108/') > 0) {
            versionName = 'Denmark - ' + vers.substring(47 + offset);
          } else if (vers.indexOf('/11000181102/') > 0) {
            versionName = 'Estonia - ' + vers.substring(43 + offset);
          } else if (vers.indexOf('/11000315107/') > 0) {
            versionName = 'France - ' + vers.substring(43 + offset);
          } else if (vers.indexOf('/11000220105/') > 0) {
            versionName = 'Ireland - ' + vers.substring(43 + offset);
          } else if (vers.indexOf('/51000202101/') > 0) {
            versionName = 'Norway - ' + vers.substring(43 + offset);
          } else if (vers.indexOf('/5631000179106/') > 0) {
            versionName = 'Uruguay - ' + vers.substring(45 + offset);
          } else if (vers.indexOf('/450829007/') > 0) {
            versionName = 'Latinoamérica - ' + vers.substring(41 + offset);
          } else if (vers.indexOf('/1303956008/') > 0) {
            versionName = 'NCPT - ' + vers.substring(42 + offset);
          } else if (vers.indexOf('/11000146104/') > 0) {
            versionName = 'Netherlands - ' + vers.substring(43 + offset);
          } else if (vers.indexOf('/15561000146104/') > 0) {
            versionName = 'Netherlands patient-friendly - ' + vers.substring(46 + offset);
          } else if (vers.indexOf('/45991000052106/') > 0) {
            versionName = 'Sweden - ' + vers.substring(46 + offset);
          } else if (vers.indexOf('/20611000087101/') > 0) {
            versionName = 'CA - ' + vers.substring(46 + offset);
          } else if (vers.indexOf('/21000210109/') > 0) {
            versionName = 'NZ - ' + vers.substring(43 + offset);
          } else if (vers.indexOf('/332351000009108/') > 0) {
            versionName = 'Veterinary - ' + vers.substring(47 + offset);
          } else {
            console.log('unknown snomed version', vers);
          }

          if (vers.indexOf('http://snomed.info/xsct') === 0) {
            var index = versionName.indexOf("-");
            versionName = versionName.slice(0, index) + ' (Exp)' + versionName.slice(index);
          }

          return {
            'name': versionName,
            'version': vers,
          };
        })
        .sort(function (a,b) {
          var af = a.name.split('-'),
              bf = b.name.split('-'),
              n = af[0].localeCompare(bf[0], 'en', {'sensitivity': 'base', 'numeric': true, 'ignorePunctuation': true});
          if (n === 0) {
            return -af[1].localeCompare(bf[1]);
          }
          return n;
        });
      }, function (error) {
        console.log('ERROR', error);
      });
  }

  return {
    restrict: 'E',
    bindToController: true,
    controllerAs: 'ctrl',
    scope: {
      endpoint: '=',
      version: '=',
    },
    templateUrl: 'sct-vers.html',
    link: function (scope, elem) {
      scope.$watch('endpoint', function() {
        getVersions(scope, scope.$http);
      });
    },
    controller: ['$scope', '$http', function($scope, $http) {
      $scope.fn = $scope.$parent.fn;
      $scope.$http = $http;
    }],
  };

}).directive('eResults', function() {
  var counter = 0;

  function runQuery($scope, $http, ecl, version, start, rows) {
    var url = $scope.endpoint + '/ValueSet/$expand',
        prefix = version || 'http://snomed.info/sct',
        params = {
          url: prefix + '?fhir_vs=ecl/' + encodeURIComponent(toCanonicalEcl(ecl)),
          count: rows,
          offset: start,
        };

// console.log('VERSION on query: ', version);

    var valueSet = {
        resourceType: "ValueSet",
        compose: {
          include: [{
            system: "http://snomed.info/sct",
            // version: version,
            filter: [{
              property: "constraint",
              op: "=",
              value: toCanonicalEcl(ecl),
            }]
          }],
        }
      },
      body = {
        "resourceType": "Parameters",
        "parameter": [{
            "name": "valueSet",
            "resource": valueSet,
          }, {
            "name": "count",
            "valueInteger": 50000,
          }, {
            "name": "offset",
            "valueInteger": 0,
          }, {
            "name": "includeDesignations",
            "valueBoolean": false,
          }]
          // "&field=shortId&field=label&versionedId=" +
      },
      config = {
        'content-type': 'application/json+fhir',
        'accept': 'application/json+fhir',
      };

    if (version) {
      valueSet.compose.include[0].version = version;
    }

// console.log('$scope', $scope);
    $scope.results = {
      total: 'working...',
      name: $scope.name
    };

    $scope.id = $scope.axioms = undefined;

    var link = document.getElementById('dummyLink');

    // If 'internal CSIRO', or client is authenticated, then allow download
    if ("csiro" === $scope.$parent.download || (client.state.tokenResponse && client.state.tokenResponse.access_token)) {
      document.getElementById('download').style.display = '';
    }

    function paramsToMap(params) {
      // simplistic and assumes only one non-name prop and value, which is the case for the properties we are interested in
      var map = {};
      params.forEach(p => {
        var valKey = Object.keys(p).filter(k => 'name' !== k)[0];
        map[p.name] = p[valKey];
      });
      return map;
    }

    function getChunks(offset, cb) {
      body.parameter[2].valueInteger = offset;
      console.log('get expansion with offset=' + offset);

      return $http.post(url, body, config)
        .then(function (response) {
          var json = response.data,
              props = paramsToMap(json.expansion.parameter),
              total = json.expansion.total,
              count = json.expansion.contains.length,
              rows = json.expansion.contains.map(cb);
          console.log(total, offset, props.offset, count, offset+count);
          console.log('json', json);
          if (props.offset + count < total) {
            return getChunks(offset + count, cb)
              .then(function (nextRows) {
                return rows.concat(nextRows);
              });
          } else {
            return rows;
          }
        });
      }

    $scope.showMore = function() {
      params.count += 100;
      console.log(params);
      return expandIt(++counter);
    }

    $scope.downloadECL = function() {
      body.parameter[3].valueBoolean = false;
      getChunks(0, function(row) { return row.code + ',"' + row.display + '",\t' + row.code; }).then(function (csv) {
        var header = ['Concept Id,Description,Safety Code'];
        var blob = new Blob([header.concat(csv).join('\n') + '\n'], { type: "text/csv;charset=utf-8" }),
          blobUrl = window.URL.createObjectURL(blob);

        link.setAttribute('href', blobUrl);
        link.click();
        window.URL.revokeObjectURL(blobUrl);
      }, function (response) {
        console.log('ERROR', response);
      })
    };

    $scope.downloadECLasExcel = function(name) {
      body.parameter[3].valueBoolean = true;
      getChunks(0, function (row) {
          var the_fsn = '', sem_tag = '';

          const fsn = {};
          if (row.designation) {
            row.designation.forEach(function (t) {
              if (t.use && t.use.code === '900000000000003001' && t.use.system === 'http://snomed.info/sct' && t.value.endsWith(')')) {
                fsn[t.language] = t.value;
              }
            });

            const availLang = new locale.Locales(Object.keys(fsn));
            const userLang = new locale.Locales(Endpoint.getLanguage());
            const bestMatch = userLang.best(availLang);

            the_fsn = fsn[bestMatch.toString()] || fsn[Object.keys(fsn)[0]];
            sem_tag = the_fsn.replace(/^.*[(]/,'').slice(0,-1);
          }

          return [row.code + '', row.display, the_fsn, sem_tag];
      }).then(function (csv) {
        var wb = XLSX.utils.book_new();
        var ws = XLSX.utils.aoa_to_sheet([
          ['Concept Id', 'Description', 'Fully Specified Name', 'Semantic Tag']
        ].concat(csv));
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        XLSX.writeFileXLSX(wb, name + '.xlsx');
      }, function (response) {
        console.log('ERROR', response);
      })
    };

//       $http.post(url, body, config)
//         .then(function (response) {
// if (false) {
//           var json = response.data,
//               uri = 'data:application/vnd.ms-excel;base64,',
//               template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
//               base64 = function(s) {
//                 return window.btoa(unescape(encodeURIComponent(s)))
//               },
//               format = function(s, c) {
//                 return s.replace(/{(\w+)}/g, function(m, p) {
//                   return c[p];
//                 })
//               },
//               htmls = '<table><thead><tr><th>Code</th><th>Display</th></tr></thead><tbody>' +
//                       json.expansion.contains.map(function (row) {
//                         return '<tr><td>' + row.code + '</td><td>' + row.display + '</td></tr>';
//                       }).join('\n') +
//                       '</tbody></table>',
//               ctx = {
//                 worksheet : 'Worksheet',
//                 table : htmls
//               };

//           link.setAttribute('href', uri + base64(format(template, ctx)));
//           link.setAttribute('download', 'export.xls');
//           link.click();
// } else {
//           var json = response.data,
//               csv = json.expansion.contains.map(function (row) {
//                       return row.code + ',"' + row.display + '",\t' + row.code
//                     }).join('\n'),
//               blob = new Blob(['Concept Id,Description,Safety Code\n' + csv + '\n'], {type: "text/csv;charset=utf-8"}),
//               blobUrl = window.URL.createObjectURL(blob);

//           link.setAttribute('href', blobUrl);
//           link.click();
//           window.URL.revokeObjectURL(blobUrl);
//           console.log('json', json);
// }
//         }, function (response) {
//           console.log('ERROR', response);
//         });
//    };

    function expandIt(token) {
    var getConfig = {...config, params: params};

    return $http.get(url, getConfig)
      .then(function(response) {
        console.log('Expand', response.data.expansion.total);
        if (counter === token) {
          var vers = response.data.expansion.parameter.filter(function(p) {return p.name === 'version'}) || [{}];
          var vv = vers[0].valueUri.split('|');
          if (vv.length > 1) {
            $scope.expVersion = decodeURIComponent(vv[1]);
          } else {
            $scope.expVersion = decodeURIComponent(vv[0]);
          }
          $scope.results = response.data.expansion;
          const timestamp = new Date($scope.results.timestamp);
          const date = dateToYMD(timestamp);
          const time = dateToHMS(timestamp);
          $scope.count = rows;
          $scope.results.name = $scope.name + '-' + date + '-' + time;
        } else {
          console.log('Stale', counter, token);
        }
      }, function(error) {
        $scope.results = {
          message: error,
          name: $scope.name
        };
      });
    }

    return expandIt(++counter);
  }

  function dateToHMS(date) {
    return '' + date.getHours() + date.getMinutes() + date.getSeconds();
  }

  function dateToYMD(date) {
    var d = date.getDate();
    var m = date.getMonth() + 1; //Month from 0 to 11
    var y = date.getFullYear();
    return '' + y + (m<=9 ? '0' + m : m) + (d <= 9 ? '0' + d : d);
  }

  function simplify(str) {
    return str.replace(/\W/g, '_');
  }

  return {
    restrict: 'E',
    scope: {
      ecl: '=',
      name: '=',
      endpoint: '=',
      version: '=',
    },
    templateUrl: 'e-results.html',
    link: function postLink(scope, elem) {
      var prevEcl, prevEndpoint, prevVersion;

      DiagrammingView.settings.Endpoint = Endpoint;
      DiagrammingView.init();

      function maybeQuery() {
console.log('maybeQuery', prevVersion, scope.version);
        if (prevEcl !== scope.ecl || prevEndpoint != scope.endpoint || prevVersion != scope.version) {
          prevEcl = scope.ecl;
          prevEndpoint = scope.endpoint;
          prevVersion = scope.version;
          DiagrammingView.showConcepts([]);
          runQuery(scope, scope.$http, scope.ecl, scope.version, 0, 100);
        }
      }

      scope.$watch('ecl', function() {
        maybeQuery();
      });
      scope.$watch('endpoint', function() {
        maybeQuery();
      });
      scope.$watch('version', function() {
        maybeQuery();
      });
    },
    controller: ['$scope', '$http', function($scope, $http) {
      $scope.$http = $http;

      Endpoint.$http = $http;
      Endpoint.ep = $scope.endpoint;

      $scope.setAxioms = (concept) => {
        DiagrammingView.showConcepts([{
          s: 'http://snomed.info/sct',    
          c: concept,
          v: $scope.expVersion,
        }])
      }
    }]
  };
});

// Now we can start the AngularJS bootstrap
angular.element(document).ready(function() {
  angular.bootstrap(angular.element(document), ['eclbuilder']);

  // clear any previous error state if we successfully reach this point
  const authKey = 'smart_auth_attempted';
  const retryKey = 'smart_auth_retry_count';
  sessionStorage.removeItem('shrimp-ecl-error');
  sessionStorage.removeItem(authKey);
  sessionStorage.removeItem(retryKey);
});

}).catch(function (error) {
  console.log('ERROR!!!', error);
  try {
    Sentry.captureException(error);
  } catch (err) {
    console.log('Sentry error', err);
  }

  const authKey = 'smart_auth_attempted';
  const retryKey = 'smart_auth_retry_count';
  const ERROR_KEY = 'shrimp-ecl-error';

  function relaunch(err, authIss) {
    sessionStorage.setItem(ERROR_KEY, err);
    const urlParams = new URLSearchParams(window.location.search);
    const iss = authIss || urlParams.get('iss') || urlParams.get('fhir') || 'https://tx.ontoserver.csiro.au/fhir';
    urlParams.set('iss', iss);
    window.location = `launch.html?${urlParams.toString()}`
  }

  const authIss = sessionStorage.getItem(authKey);
  const retries = parseInt(sessionStorage.getItem(retryKey) || "0");
  if (authIss && retries < 2) {
    sessionStorage.setItem(retryKey, String(retries + 1));
    const priorError = sessionStorage.getItem(ERROR_KEY);
    const msg = priorError ? `${error}\n${priorError}` : `${error}`;
    if (confirm(`${msg}\n\nClick OK to re-launch.\n`)) {
      relaunch(error, authIss);
    }
  } else {
    sessionStorage.removeItem(authKey);
    sessionStorage.removeItem(retryKey);

    relaunch(error);
  }
});
